// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__3hS5Y","itemA":"Write_itemA__JO8Rs","itemB":"Write_itemB__3JBp1","itemC":"Write_itemC__2_oqH","itemD":"Write_itemD__21_nM"};